import { render } from "./AssignProjectForm.vue?vue&type=template&id=01532d7c"
import script from "./AssignProjectForm.vue?vue&type=script&lang=js"
export * from "./AssignProjectForm.vue?vue&type=script&lang=js"

import "./AssignProjectForm.vue?vue&type=style&index=0&id=01532d7c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__